import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { shipmentsAPI } from "../../../api/shipments/shipments"

const initialState = {
    shipmentTrc: null,
    popupState: {
        opened: false,
    },
    shipment: null,
    uploading: false,
    status: null,
    error: null,
}

export const uploadEvents = createAsyncThunk(
    "shipmentEvents/uploadEvents",
    async (shipmentTrc, {rejectWithValue}) => {
        const resp = await shipmentsAPI.uploadEvents(shipmentTrc)
        if(resp.ok) {
            return {shipment: resp.shipment}
        }
        if(resp.unauthorized) {
            return rejectWithValue({err: "unauthorized"})
        }
        return rejectWithValue({err: resp.err ?? "something_went_wrong"})
    }
)

const shipmentEventsSlice = createSlice({
    name: "shipmentEvents",
    initialState,
    reducers: {
        openShipmentEventsPopup(state, action) {
            state.popupState.opened = true
            state.shipmentTrc = action.payload.shipmentTrc
            state.uploading = true;
        },
        closeShipmentEventsPopup(state) {
            state.popupState.opened = false
            state.shipment = null
        },
        setUploadingToFalse(state) {
            state.uploading = false
        },
        setEventsError(state, action) {
            state.error = action.payload.err ?? null
        },
        
    },
    extraReducers(builder) {
        builder.addCase(uploadEvents.fulfilled, (state, action) => {
            state.status = "fulfilled"
            let shipment = action.payload?.shipment
            if (!shipment) {
                state.shipment = null
                state.error = action.payload.err ?? null
                state.status = "rejected"
            }

            state.shipment =  shipment
        })
        builder.addCase(uploadEvents.pending, (state) => {
            state.status = "pending"
            state.error = null
        })
        builder.addCase(uploadEvents.rejected, (state, action) => {
            state.status = "rejected"
            if (state.error === "unauthorized") {
                state.error = "please_authorize"
                return
            }
            state.error = action.payload.err ?? null
        })
    }
})

export const selectEventsShipment = (state) => state.shipmentEvents.shipment
export const selectShipmentEventsPopupState = (state) => state.shipmentEvents.popupState
export const selectEventsShipmentTrc = (state) => state.shipmentEvents.shipmentTrc
export const selectShipmentEventsStatus = (state) => state.shipmentEvents.status
export const selectShipmentEventsError = (state) => state.shipmentEvents.error
export const selectShipmentEventsUploading = (state) => state.shipmentEvents.uploading


export const { 
    openShipmentEventsPopup, 
    closeShipmentEventsPopup, 
    setEventsError, 
    setUploadingToFalse
} = shipmentEventsSlice.actions

export default shipmentEventsSlice.reducer